var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBankCard = function SvgBankCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71,
    height: 47,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#23A971",
    fillRule: "evenodd",
    d: "M67.63 0c.963 0 1.685.24 2.407.96.722.719.963 1.678.963 2.397v40.286c0 .959-.24 1.678-.963 2.398-.722.72-1.684.959-2.407.959H3.37c-.963 0-1.685-.24-2.407-.96C.24 45.562 0 44.603 0 43.884V3.357C0 2.398.24 1.68.963.96 1.685.24 2.647 0 3.369 0H67.63Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#035F48",
    fillRule: "evenodd",
    d: "M70.986 27.898v15.745c0 .959-.24 1.678-.962 2.398-.722.72-1.685.959-2.407.959H3.37c-.963 0-1.685-.24-2.406-.96C.24 45.562 0 44.603 0 43.884v-5.697c17.301 6.721 44.426 5.222 56.755.48 6.47-2.488 10.924-6.116 14.231-10.768ZM70.79 2.198C49.9 1.263 18.36 6.224 0 12.14V3.357C0 2.398.24 1.68.963.96 1.684.24 2.647 0 3.369 0h64.248c.963 0 1.685.24 2.407.96.372.37.616.805.766 1.238Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#03854F",
    d: "M55.793 17.046s-4.416-3.074-2.355-7.083C54.4 8.091 56.521 9.211 59 7.258c-5.014-1.316-10.082 2.568-7.122 7.987 0 0 2.61 4.6 6.508 3.618-.885-.314-1.764-.898-2.593-1.817Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#03854F",
    d: "M59.263 6.458a7.617 7.617 0 0 1-.605.499c.172.042.344.09.514.143 4.467 1.391 7.796 6.076 4.862 7.69-3.55 1.954-3.313 3.09-5.678 3.822-.12.038-.24.07-.356.097 4.002 1.335 8.126-2.168 8.904-5.568.962-4.21-5.556-8.585-7.641-6.683Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#035F48",
    d: "M63.98 14.998c2.698-1.648-.361-6.431-4.47-7.852A7.209 7.209 0 0 0 59.038 7c-2.45 2.02-4.546.862-5.497 2.796-2.035 4.147 2.328 7.326 2.328 7.326.82.951 1.688 1.554 2.564 1.878a4.86 4.86 0 0 0 .327-.099c2.175-.748 1.956-1.908 5.22-3.903Z"
  })));
};
export default SvgBankCard;